import styles from 'partials/dashboard/add-story-card.module.scss';

export const AddStoryCard = ({ title, icon, onClick }) => {
	const Icon = icon;
	return (
		<div
			role="button"
			className={styles.card}
			onClick={onClick}
			onKeyPress={onClick}
			tabIndex="-1">
			<Icon size="38" className={styles.icon} />
			<span className={styles.title}>{title}</span>
		</div>
	);
};
